import React from 'react';
import '../styles/manual-trip.style.scss';
import { TripsRoot } from './../components/trips-component/trips-root-component/trips-root.component';

export const TripsPage = (props) => {

    return (
        <div className="manual-trip-page-root">
            <TripsRoot />
        </div>
    )
}